import { render, staticRenderFns } from "./TablePaginatedOrdersComplex.vue?vue&type=template&id=5ac36a12&scoped=true"
import script from "./TablePaginatedOrdersComplex.vue?vue&type=script&lang=js"
export * from "./TablePaginatedOrdersComplex.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedOrdersComplex.vue?vue&type=style&index=0&id=5ac36a12&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac36a12",
  null
  
)

export default component.exports